// extracted by mini-css-extract-plugin
export default {"container":"FeedCardQuestion_container__J7ug6","relative-date":"FeedCardQuestion_relative-date__Vhd9t","content":"FeedCardQuestion_content__7sEgG"};